import React from 'react'
import PropTypes from 'prop-types'
import { image } from 'services'

import { IonIcon } from 'controls'
import { Card } from 'components'

import {
  propertyDocInfoStyles,
  propertyFooterStyles,
} from './styles'

const BasePropertyDocInfo = ({
  propertyFooter,
  description,
  title,
  srcImage
}) => {
  return (
    <section className="base-property-doc-info">
      <Card alignLeft shadow rounded>
        <header className="header">
          <div className="icon">
            <img src={image(srcImage)} alt={title} />
          </div>
          <h4 className="title">{title}</h4>
        </header>

        <div className="description">
          <p>{description}</p>
        </div>

        <footer>{propertyFooter}</footer>
      </Card>
      <style jsx>{propertyDocInfoStyles}</style>
    </section>
  )
}

BasePropertyDocInfo.propTypes = {
  propertyFooter: PropTypes.any,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  srcImage: PropTypes.string.isRequired // A s3 url image
}

const PropertyFooter = ({ messageFooter, highlightMessage }) => {
  return (
    <div className="property-footer">
      {highlightMessage && (
        <div className="footer-icon">
          <IonIcon icon="md-checkmark" size="small" className="check-icon" />
        </div>
      )}
      <p>
        <span className="highlight-message">{highlightMessage}</span>{' '}
        {messageFooter}
      </p>
      <style jsx>{propertyFooterStyles}</style>
    </div>
  )
}

const PropertyDocInfo = ({
  messageFooter,
  highlightMessage,
  className,
  ...rest
}) => {
  return (
    <div className={className}>
      <BasePropertyDocInfo
        {...rest}
        propertyFooter={
          <PropertyFooter
            highlightMessage={highlightMessage}
            messageFooter={messageFooter}
          />
        }
      />
    </div>
  )
}

PropertyDocInfo.propTypes = {
  className: PropTypes.string,
  messageFooter: PropTypes.string,
  highlightMessage: PropTypes.string
}

export default PropertyDocInfo
